export default "__VITE_ASSET__4c10c60c__"